import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

"use strict";
$.extend(uly.actions, {
    save_settings_as_default:function(ev,$elt,ui) {
        var settings = uly.page.get_persistent_settings();
        settings["default"] = true;
        uly.page.save_settings(settings);
    },
    reset_settings:function(ev,$elt,ui) {
        uly.page.delete_settings().done(function(result) {
            uly.utils.show_results(result);
            uly.page.reload();
        });
    },
    reset_settings_for_all: function(ev, $elt, ui) {
        uly.page.delete_settings(true).done(function(result) {
            uly.utils.show_results(result);
            uly.page.reload();
        });
    }
});
